import { useEffect, type ReactNode } from 'react';

interface ModalScrimProps {
  width?: number;
  children: ReactNode;
  onClose: () => void;
  labelledBy?: string;
}

/** Centered modal with a half-opaque scrim. Escape closes; click-outside
 *  closes. Used by the Edit-role and Deactivate dialogs. */
export default function ModalScrim({
  width = 560,
  children,
  onClose,
  labelledBy,
}: ModalScrimProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-10"
      style={{ background: 'rgba(15, 25, 18, 0.42)' }}
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className="bg-white dark:bg-[#1a1f1c] rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-full"
        style={{ width, maxWidth: '100%' }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
